/**
 * Prod itinerary (getPackageItineraryData result, plus `activity`) as DS
 * TripSummaryCard detail rows: { icon, label, secondaryLabel, description }.
 */
const itineraryDetailRows = itinerary => {
  if (!itinerary) {
    return [];
  }
  const { title, dates, descriptions, activity } = itinerary;
  const row = (icon, key) => ({
    icon,
    label: title[key],
    secondaryLabel: dates[key] || undefined,
    description: descriptions[key] || undefined,
  });
  // Same split as prod's PackageItinerary: crosshairs for hunts, hiking otherwise.
  const activityIcon = activity === 'hunt' ? 'Crosshairs' : 'PersonHiking';
  return [row('Clock', 'checkIn'), row(activityIcon, 'activity'), row('Clock', 'checkOut')];
};

export default itineraryDetailRows;
